import React, { useState, useEffect, lazy, Suspense } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Contact from "./components/Contact/Contact";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

const loadResume = () => import("./components/Resume/ResumeNew");
const Resume = lazy(loadResume);

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    // Hide the preloader as soon as the page has finished loading
    const done = () => upadateLoad(false);
    if (document.readyState === "complete") {
      done();
      return;
    }
    window.addEventListener("load", done);
    return () => window.removeEventListener("load", done);
  }, []);

  useEffect(() => {
    // Warm up the resume page in the background so it opens quickly
    if (load) return;
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
    idle(loadResume);
  }, [load]);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Suspense fallback={null}><Resume /></Suspense>} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
